import classNames from "classnames";
import Image from "next/image";
import { generateImageUrl } from "@/utils";
import { Inter } from "next/font/google";
import { trackItemTapped } from "@/utils/mixpanel";
import { setSearchParams } from "@/utils/url";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const TopPlaceImage = ({ priority, title, positionNumber, id }) => {
    const src = generateImageUrl({
        imageId: id,
        width: 622,
        height: 420,
        reason: "top-ten-gf-map",
    });

    return (
        <div
            id="generic-modal-trigger-top-place-image"
            className={classNames({
                "relative mb-4 bg-slate-200 overflow-hidden": true,
                // 'animate-pulse': !isImageLoaded,
            })}>
            <div
                className={classNames({
                    "border-r border-b border-zinc-200": false,
                    "absolute z-10 top-0 left-0 w-[57px] h-[55px]": true,
                    "p-3 bg-neutral-100 flex justify-between items-center": true,
                })}>
                <span
                    className={classNames(inter.className, {
                        "w-full text-center text-sky-950 text-[27px]": true,
                        "font-bold leading-10 tracking-wide": true,
                    })}>
                    {positionNumber < 10 ? `0${positionNumber}` : positionNumber}
                </span>
            </div>
            <div
                onClick={() => {
                    trackItemTapped(MixpanelValues.ItemTapped.IMAGE);
                }}
                className="relative w-full h-56 md:h-[420px] overflow-hidden">
                <Image
                    fill
                    sizes="100%"
                    src={src}
                    alt={title}
                    quality={50}
                    style={{ objectFit: "cover", objectPosition: "center" }}
                    priority={priority}
                    loading={priority ? "eager" : "lazy"}
                // onLoad={() => setIsImageLoaded(true)}
                />
                {/*{isBlurred ? <div className="bottom-image-blur"/> : null}*/}
            </div>
        </div>
    );
};
